<template>
    <div class="row faq-container align-items-center mb-3">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <label class="form-label mb-1">Question</label>
            <input type="text" class="form-control faq-input-text" placeholder="Question" v-model="faq.question" />
        </div>

        <div class="row">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <label class="form-label mb-1">Réponse</label>
                <div ref="editor"></div>
            </div>
            <div class="col-lg-2 col-md-12 col-sm-12">
                <div class="d-flex align-items-center mt-2">
                    <!-- <button type="button" class="btn btn-up-down me-1 mb-3" @click="moveUp">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M10.4165 5L6.49404 8.9225C6.41667 8.99987 6.3553 9.09172 6.31342 9.19281C6.27155 9.2939 6.25 9.40225 6.25 9.51167C6.25 9.62109 6.27155 9.72943 6.31342 9.83052C6.3553 9.93161 6.41667 10.0235 6.49404 10.1008C6.57141 10.1782 6.66326 10.2396 6.76435 10.2815C6.86544 10.3233 6.97379 10.3449 7.08321 10.3449C7.19263 10.3449 7.30097 10.3233 7.40206 10.2815C7.50315 10.2396 7.595 10.1782 7.67237 10.1008L9.58321 8.19V14.5117C9.58321 14.7327 9.67101 14.9446 9.82729 15.1009C9.98357 15.2572 10.1955 15.345 10.4165 15.345C10.6376 15.345 10.8495 15.2572 11.0058 15.1009C11.1621 14.9446 11.2499 14.7327 11.2499 14.5117V8.19L13.1607 10.1008C13.2379 10.1785 13.3297 10.2401 13.4308 10.2822C13.5319 10.3242 13.6404 10.3459 13.7499 10.3459C13.8594 10.3459 13.9678 10.3242 14.0689 10.2822C14.17 10.2401 14.2618 10.1785 14.339 10.1008C14.4165 10.0235 14.4779 9.93167 14.5199 9.83058C14.5618 9.72948 14.5834 9.62111 14.5834 9.51167C14.5834 9.40222 14.5618 9.29385 14.5199 9.19276C14.4779 9.09166 14.4165 8.99982 14.339 8.9225L10.4165 5Z"
                                fill="#94A3B8"
                            />
                        </svg>
                    </button>
                    <button type="button" class="btn btn-up-down me-1 mb-3" @click="moveDown">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M9.58346 15L13.506 11.0775C13.5833 11.0001 13.6447 10.9083 13.6866 10.8072C13.7284 10.7061 13.75 10.5978 13.75 10.4883C13.75 10.3789 13.7284 10.2706 13.6866 10.1695C13.6447 10.0684 13.5833 9.97654 13.506 9.89917C13.4286 9.8218 13.3367 9.76042 13.2356 9.71855C13.1346 9.67668 13.0262 9.65513 12.9168 9.65513C12.8074 9.65513 12.699 9.67668 12.5979 9.71855C12.4968 9.76042 12.405 9.8218 12.3276 9.89917L10.4168 11.81L10.4168 5.48833C10.4168 5.26732 10.329 5.05536 10.1727 4.89908C10.0164 4.7428 9.80447 4.655 9.58346 4.655C9.36244 4.655 9.15048 4.7428 8.9942 4.89908C8.83792 5.05536 8.75013 5.26732 8.75013 5.48833V11.81L6.83929 9.89917C6.76208 9.82151 6.67028 9.75989 6.56917 9.71784C6.46806 9.67579 6.35963 9.65414 6.25013 9.65414C6.14062 9.65414 6.03219 9.67579 5.93108 9.71784C5.82997 9.75989 5.73817 9.82151 5.66096 9.89917C5.5835 9.97649 5.52206 10.0683 5.48013 10.1694C5.4382 10.2705 5.41663 10.3789 5.41663 10.4883C5.41663 10.5978 5.4382 10.7061 5.48013 10.8072C5.52206 10.9083 5.5835 11.0002 5.66096 11.0775L9.58346 15Z"
                                fill="#94A3B8"
                            />
                        </svg>
                    </button> -->
                    <button type="button" class="btn btn-minuss btn-outline-secondary me-1 mb-3" @click="remove">-</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        faq: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            editorInstance: null,
        }
    },
    mounted() {
        this.initializeEditor()
    },
    beforeDestroy() {
        if (this.editorInstance) {
            this.editorInstance.destroy().catch((error) => console.error('Error destroying editor:', error))
        }
    },
    methods: {
        initializeEditor() {
            ClassicEditor.create(this.$refs.editor, {
                toolbar: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    '|',
                    'link',
                    'blockQuote',
                    '|',
                    'bulletedList',
                    'numberedList',
                    '|',
                    'insertTable',
                    'imageUpload',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    'alignment:left',
                    'alignment:center',
                    'alignment:right',
                    'alignment:justify',
                    '|',
                    'fontSize',
                    'fontColor',
                    'fontBackgroundColor',
                    '|',
                    'highlight',
                    'removeFormat',
                ],
                language: 'fr',
                image: {
                    toolbar: ['imageTextAlternative', 'imageStyle:full', 'imageStyle:side'],
                    styles: ['full', 'side'],
                    upload: {
                        types: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff'],
                    },
                },
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                fontSize: {
                    options: [9, 11, 13, 'default', 17, 19, 21],
                    supportAllValues: false,
                },
                fontColor: {
                    columns: 5,
                    documentColors: 10,
                },
                fontBackgroundColor: {
                    columns: 5,
                    documentColors: 10,
                },
                heading: {
                    options: [
                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                    ],
                },
                alignment: {
                    options: ['left', 'center', 'right', 'justify'],
                },
                link: {
                    decorators: {
                        addTargetToExternalLinks: true,
                        defaultProtocol: 'https://',
                        openInNewTab: true,
                        openInNewTab: {
                            mode: 'manual',
                            label: 'Ouvrir dans un nouvel onglet',
                            attributes: {
                                target: '_blank',
                                rel: 'noopener noreferrer',
                            },
                        },
                    },
                },
                placeholder: 'Tapez votre réponse ici...',
                // Plugins
                removePlugins: ['MediaEmbed'],
                extraPlugins: [], // extra plugins if needed
                licenseKey: '', // license key if you're using a commercial CKEditor version
            })
                .then((editor) => {
                    this.editorInstance = editor
                    editor.setData(this.faq.answer)
                    editor.model.document.on('change:data', () => {
                        this.faq.answer = editor.getData()
                    })
                })
                .catch((error) => {
                    console.error('There was a problem initializing CKEditor:', error)
                })
        },
        remove() {
            this.$emit('remove', this.index)
        },
        moveUp() {
            this.$emit('move-up-faq', this.index)
        },
        moveDown() {
            this.$emit('move-down', this.index)
        },
    },
}
</script>

<style scoped></style>
